export default __webpack_public_path__ + "static/media/FacebookQRCodeTW.e49360f8.jpeg";